import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="block mb-12 text-xs tracking-[0.25em] uppercase text-[#9CA3AF] hover:text-[#F25C32] transition-colors"
          data-testid="back-to-site"
        >
          ← Volver al sitio
        </Link>

        <div className="text-xs tracking-[0.3em] uppercase text-[#F25C32] mb-3">— Acceso administrador</div>
        <h1 className="heading-display text-4xl md:text-5xl text-[#F5F5F0] mb-10">
          Entrar al<br />panel
        </h1>

        <form onSubmit={onSubmit} className="space-y-2">
          <div>
            <label className="text-xs tracking-[0.25em] uppercase text-[#9CA3AF]">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="editorial-input"
              placeholder="santiago@santiagovo.com"
              required
              data-testid="admin-login-email"
            />
          </div>

          <div className="pt-6">
            <label className="text-xs tracking-[0.25em] uppercase text-[#9CA3AF]">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="editorial-input"
              placeholder="••••••••"
              required
              data-testid="admin-login-password"
            />
          </div>

          <div className="pt-8">
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#F25C32] hover:bg-[#D94E28] text-white rounded-full px-10 py-4 uppercase tracking-[0.25em] text-sm font-bold transition-all disabled:opacity-50"
              data-testid="admin-login-button"
            >
              {loading ? "Entrando…" : "Entrar"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
